import React from 'react';
import { graphql } from 'react-apollo';
import { GET_REPORT_BY_PUBLISHER_REF_DATE, ADD, EDIT } from "../../../../queries/payments";
import UploadReceiptForm from "../components/form";
import { Mutation } from "react-apollo";

const uploadFunc = ({publisherId, publisherName, referenceDate, USDValue, data: { paymentReceiptByIdAndRefDate: paymentData, loading, error }}) => {
  const hasReceipt = () => {
    if(paymentData !== undefined && paymentData.publisherId !== undefined)
        return true;
    else
        return false;
  }
  
  return (
    <>
    {
    (loading) ? (<>Loading...</>) :
    (<>
        {hasReceipt() === true ?
            (<Mutation mutation={EDIT}>
                {updatePaymentReceipt => (
                    <UploadReceiptForm query_f = {updatePaymentReceipt} publisherName={publisherName} {...paymentData}/>
                )}
            </Mutation>) : 
            (<Mutation mutation={ADD}>
                {createPaymentReceipt => (
                    <UploadReceiptForm query_f = {createPaymentReceipt} publisherId={publisherId} publisherName={publisherName} referenceDate={referenceDate} USDValue={USDValue}/>
                )}
            </Mutation>)
        }
    </>)
    }
    </>
  );
}

export const UploadReceipt = graphql(GET_REPORT_BY_PUBLISHER_REF_DATE, 
    { 
        options: (props) =>(
        { 
            variables: { publisherId: props.publisherId, referenceDate: props.referenceDate },
            fetchPolicy: 'network-only'
        })
    })(uploadFunc);